module.exports = __webpack_public_path__ + "img/ico_curtain_3.fae67b9e.png";